export interface JsonContractState {
  id: number;
  name: string;
  year: string;
}

export class ContractState {
  id: number;
  name: string;
  year: string;

  constructor(jsonContractState: JsonContractState = null) {
    this.id = jsonContractState.id;
    this.name = jsonContractState.name;
    this.year = jsonContractState.year;
  }
}
